<template>
    <div class="container">
        <div class="header">
            <div class="heading">
                <img class="backArrow" src="../../assets/backArrow.svg" @click="onBackClicked"/>
                <p class="title">Approval</p>
            </div>
            <div class="btnWrapper" v-if="item.accountStatus == 'PENDING'">
                <div @click="handleBtnClick" :data-status="'REJECTED'" class="btn">Reject</div>
                <div @click="handleBtnClick" :data-status="'APPROVED'" class="submitBtn">Approve & Send TnC</div>
            </div>
        </div>
        <div class="mainContainer">
            <div v-if="apiErrorMessage" class="errorContainer"> 
                <div class="errorHeading">Error</div>
                <div class="apiErrorMessage">{{ apiErrorMessage }}</div>
            </div>
            <div class="subHeading">{{roles[item.role]}} Details </div>
            <div class="formContainer">
                <div>
                    <div  class="label">Name</div>
                    <div class="content"> 
                        <input disabled class="textbox" v-model="fields.name" placeholder="Enter here" />
                    </div>
                </div>
                <div>
                    <div  class="label">Email ID</div>
                    <div class="content"> 
                        <input disabled class="textbox" v-model="fields.email" placeholder="Enter here" />
                    </div>
                </div>
                <div v-if="item.role == 'SELLER' || item.role == 'BRAND'">
                    <div  class="label">User ID</div>
                    <div class="content"> 
                        <input disabled class="textbox" v-model="fields.userId" placeholder="Enter here" />
                    </div>
                </div>
                <div v-if="item.role == 'AGENCY'">
                    <div  class="label">Primary Contact Number</div>
                    <div class="content">
                        <input disabled class="textbox" v-model="fields.primaryContactNumber" placeholder="Enter here" />
                    </div>
                </div>
                <div v-if="item.role == 'AGENCY'">
                    <div  class="label">Secondary Contact Number</div>
                    <div class="content">
                        <input disabled class="textbox" v-model="fields.secondaryContactNumber" placeholder="Enter here" />
                    </div>
                </div>
                <div v-if="item.role == 'AGENCY'">
                    <div  class="label">Address</div>
                    <div class="content"> 
                        <textarea disabled class="textbox textarea" v-model="fields.address" placeholder="Enter here" />
                    </div>
                </div>
                <div v-if="item.role == 'AGENCY'">
                    <div  class="label">Pincode</div>
                    <div class="content"> 
                        <input disabled class="textbox" v-model="fields.pincode" placeholder="Enter here" />
                    </div>
                </div>
            </div>
            <div v-if="fields.docs?.length" class="subHeading">Documents </div>
            <div class="document" v-for="doc in fields.docs" :key="doc">
                <img src="../../assets/documentIcon.svg" />
                <span class="title f-14">{{doc}}</span>
            </div>
            <div v-if="item.accountStatus !== 'APPROVED'">
                <div  class="subHeading" style="margin-bottom: 8px">Comments on rejection</div>
                <div class="content" :style="item.accountStatus !== 'PENDING' ? 'pointer-events: none;' : ''"> 
                    <textarea class="comments textarea" placeholder="Enter comments" v-model="fields.comments" />
                </div>
            </div>
            <p v-if="item.role === 'AGENCY'" class="label">
                Note: The following Documents will be stored and tracked offline for Agency onboarding:IO Doc, Registration Doc, GST Doc, PAN Card, Portfolio Details, Professional Certificate, Cancelled Cheque
            </p>
        </div>
    </div>
    <ConfirmationModal v-if="showConfirmationModal"
        :title="`Agency ${showConfirmationModal == 'APPROVED' ? 'Approval' : 'Rejection'}`"
        :subTitle="`Are you sure you want to ${showConfirmationModal == 'APPROVED' ? 'approve' : 'reject'} ${fields.name}?`"
        :leftButton="'Cancel'"
        :rightButton="'Yes'"
        @cancelClicked="handleCloseModal"
        @buttonClicked="onStatusChange"
    />
</template>

<script>
import { roleTypes } from "@/constants";
import { updateApprovalStatus } from "@/services/selfServeService"
import ConfirmationModal from "../ConfirmationModal";


export default ({
    name: 'ApprovalEdit',
    props: {
        item: Object
    },
    components: {
        ConfirmationModal
    },
    data() {
        return {
            fields: {
                name: this.item?.name ?? '',
                email: this.item?.email ?? '',
                userId: this.item?.profileId ?? '',
                primaryContactNumber: this.item?.primaryContactNumber ?? '',
                secondaryContactNumber: this.item?.secondaryContactNumber ?? '',
                address: this.item?.address ?? '',
                pincode: this.item?.pincode ?? '',
                docs: this.item?.userOnBoardingDetails?.agencyDocuments?.length ? this.item?.userOnBoardingDetails?.agencyDocuments : [],
                comments: this.item?.comments ?? ''
            },
            apiErrorMessage: null,
            roles: roleTypes,
            showConfirmationModal: ''
        }
    },
    methods: {
        onBackClicked() {
            this.$emit('backClicked')
        },
        onStatusChange() {
            const payload = {
                comments: this.showConfirmationModal == 'APPROVED' ? '""' : this.fields.comments,
                accountStatus: this.showConfirmationModal
            };
            updateApprovalStatus(this.item.userId, this.item.userType, payload)
                .then(res => res.json())
                .then(data => {
                    this.showConfirmationModal = ""
                    if(data.code == 200) {
                        this.onBackClicked()
                    } else {
                        this.apiErrorMessage = data?.errors?.[0] || data?.message
                    }
                })
                .catch(error => {
                    this.showConfirmationModal = ""
                    this.apiErrorMessage = error?.errors?.[0] || error?.message
                })
        },
        handleBtnClick(event) {
            const { status } = event.target.dataset;
            if(status == 'REJECTED' && !this.fields.comments) {
                this.apiErrorMessage =  'Comments are required';
                return;
            } else {
                this.showConfirmationModal = status;
            }
        },
        handleCloseModal() {
            this.showConfirmationModal = ""
        }
    }
})
</script>

<style scoped>
.container {
        font-family: 'Inter-Regular';
        background: #F8F8F8;
        display: flex;
        flex-direction: column;
    }
    .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        color: #401D0C;
        padding: 8px 20px 0px;
        margin-left: 0;
        background: #FFFFFF;
    }
    .title{
        margin-left:20px;
    }

    .heading {
        display: flex;
        flex-direction: row;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 140%;
        color: #333333;
        margin: 0;
    }
    .btnWrapper {
        display: flex;
        align-items: center;
        flex-direction: row;
    }
    .submitBtn {
        background: #2E31BE;
        border-radius: 4px;
        color: #FFFFFF;
        padding: 9px 16px;
        cursor: pointer;
    }
    .mainContainer {
        display: flex;
        flex-direction: column;
        margin: 1%;
        text-align: start;
        background: #FFFFFF;
        padding: 22px 24px 36px;
        border-radius: 12px;
    }
    .backArrow {
        cursor: pointer;
    }
    .btnWrapper {
    display: flex;
    align-items: center;
    flex-direction: row;
}

.btn {
    font-style: normal;
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
    color: #2E31BE;
    padding: 7px 16px;
    border: 1px solid #2E31BE;
    border-radius: 5px;
    width: fit-content;
    margin-right: 18px;
}

.submitBtn {
    background: #2E31BE;
    /* opacity: 0.3; */
    border-radius: 4px;
    color: #FFFFFF;
    padding: 9px 16px;
    cursor: pointer;
}
.subHeading {
    font-size: 16px;
    font-weight: 600;
    line-height: 22.4px;
    color: #666666;
    margin-top: 16px;
}
.formContainer {
    display: flex;
    flex-wrap: wrap;
    max-width: 600px;
    margin-top: 16px;
}
@media (min-width: 850px) {
    .formContainer > div:nth-child(even) {
        margin-left: 32px;
    }
}
.content{
    height: 100%;
}
.textbox{
    width: 274px;
    padding: 8px 12px;
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    max-width: 246px;
}
.label{
    font-weight: 600;
    font-size: 12px;
    line-height: 17px;
    color: #666666;
    margin-bottom: 12px;
    margin-top: 16px;
}
.document {
    width: 400px;
    padding: 12px 16px 12px 16px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    border: 1px solid #E0E0E0;
    margin-top: 16px;
}
.f-14 {
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    color: #41434C;
}
.textarea {
    height: 66px;
    resize: none;
    font-family: 'Inter-Regular';
}
.comments {
    padding: 8px 12px;
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    width: 288px;
    height: 118px;
}
.errorHeading{
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #EB5757;
    display: flex;
}

.apiErrorMessage{
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #666666;
    margin-top: 12px;
    margin-bottom: 24px;
}
</style>